const MATERIAL_HOVER_LABELS = {
    '/db/Icons/dungeon_drops/material_thumbnail_paradisos.webp': 'Dragon God Paradiso',
    '/db/Icons/dungeon_drops/material_thumbnail_heroSoul.webp': 'Awoken Soul',
};

/**
 * Resolve a material tooltip label from optional hover text or known image paths.
 */
export function getMaterialHoverLabel(mat, index) {
    const hover = mat?.[`hover${index}`];
    if (hover) {
        return hover;
    }

    const src = mat?.[`mat${index}`];
    if (!src) {
        return '';
    }

    if (MATERIAL_HOVER_LABELS[src]) {
        return MATERIAL_HOVER_LABELS[src];
    }

    const file = src.split('/').pop().replace(/\.[^.]+$/, '');
    return file.replace(/^material_thumbnail_|^frag/, '').replace(/[_-]+/g, ' ');
}
